import React from "react";

function ExploreNow() {
  return (
    <section id='explore-now'>
      <div className='card'>
        <h1>
          So what are you waiting for? <br /> Let's explore now!
        </h1>
        <button>Explore Now</button>
      </div>
    </section>
  );
}

export default ExploreNow;
